import { useMutation, useQueryClient } from 'react-query';
import { shutdownAlisaTemplatesQuery } from '../../../../shared/api/queries';
import request from '../../../../../../helpers/request';
import {
  shutdownEmitter,
  shutdownEvtNames,
} from '../../../../shared/constants';

const { key: templatesQueryKey } = shutdownAlisaTemplatesQuery;

const changeTemplate = async ({ templateId, data }) => {
  const res = await request.put(
    `/Alert/alisa_templates/${templateId}`,
    data,
    'Не удалось сохранить изменения в шаблоне',
    'Error'
  );

  return res;
};

export const useResponseTemplateChange = (options = {}) => {
  const queryClient = useQueryClient();

  const changeMutation = useMutation(changeTemplate, {
    ...options,
    onSuccess: (res, { templateId, data }) => {
      if (res !== 'Error') {
        queryClient.setQueryData(templatesQueryKey, (oldData) =>
          oldData.map((item) =>
            item.id === templateId
              ? {
                  id: item.id,
                  editable: item.editable,
                  name: data.name,
                  text: data.value,
                }
              : item
          )
        );
        shutdownEmitter.emit(shutdownEvtNames.autoResponseTemplateAddOrEdit, {
          id: templateId,
          text: data.value,
        });
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
